export const PATH_ROUTES = {
  home: "/",
  login: "login",
  documentsViewer: "tasks/:taskId",
  whiteList: "white-list",
};
